import moment from 'moment-timezone';

export function setDontShowMinimumInventoryReachedAlertAgainInLocalStorage(dontShowAgain: boolean) {
    window.localStorage.setItem('dontShowMinimumInventoryReachedAlertAgain', dontShowAgain as any);
    window.localStorage.setItem('lastTimeOpened', moment() as any); // bad code, transform to Iso Date time string instead
}
